<template>
	<!-- 订单拆解MRP运算 -->
        <el-dialog center title="生产拆解" :visible.sync="isShowDialog" :width="W?'58%':'70%'" :close-on-click-modal="false">
            <el-row class="" style="margin-top:20px">
                <el-table :data='spliteList' tooltip-effect='dark'  >
                    <el-table-column label='序号' min-width='60' prop='materialIndex' show-overflow-tooltip>
                        <template slot-scope="scope">
                            <span>{{scope.$index+1}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop='orderCode' label='订单号' min-width='100' show-overflow-tooltip></el-table-column>
                    <el-table-column prop='orderItemRow' label='订单行' min-width='100' show-overflow-tooltip></el-table-column>
                    <el-table-column prop='mrpType' :formatter="parseMrpType" label='生产类型' min-width='100' show-overflow-tooltip></el-table-column>
                    <el-table-column prop='materialName' label='物料名称' min-width='100' show-overflow-tooltip></el-table-column>
                    <el-table-column prop='materialCode' label='物料编码' min-width='100' show-overflow-tooltip></el-table-column>
                    <el-table-column prop='demandAmount' label='毛需求量' min-width='60' show-overflow-tooltip></el-table-column>
                    <el-table-column prop='useAmount' label='净需求量' min-width='80' show-overflow-tooltip>
                        <template slot-scope="scope">
                            <span :style="scope.row.useAmount>scope.row.availableAmount?{color:'red'}:{}">{{scope.row.producingAmount}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop='availableAmount' label='库存可用量' min-width='80' show-overflow-tooltip></el-table-column>
                    <el-table-column label='抵扣库存' min-width='60' prop='materialIndex' show-overflow-tooltip>
                        <template slot-scope="scope">
                            <el-checkbox v-model="scope.row.useStock" @change="itemCheckChange($event,scope)">
                            </el-checkbox>
                        </template>
                    </el-table-column>
                </el-table>
            </el-row>
            <span slot="footer" class="dialog-footer" style="margin-top:30px; margin-bottom:50px">
                <el-button type="primary" @click="submitSplitMaterial">确 定</el-button>
                <el-button @click="closeDoMrp">取 消</el-button>
            </span>
        </el-dialog>
        <!-- 订单拆解MRP运算 -->
</template>

<script>


export default {
	name: 'DoMrp',
	props: {
        isShow: Boolean,
        orderId:Number,
	},
	data() {
		return {
            pickerOption:{
                disabledDate(time) {
                    return time.getTime() < Date.now()
                }
            },
            isShowDialog: false,
            orderList:[],
            spliteList:[],
            itemList:[],
            W:true,
            loading:false,
		}
	},
	//el和data尚未初始化
	beforeCreate: function(){},
	//data初始化完成
	created: function(){
		
	},
	//el初始化完成
	beforeMount: function(){},
	//完成挂载
	async mounted(){
        let w = document.documentElement.clientWidth || document.body.clientWidth;
        w >= 1900 ? this.W = true : this.W = false
        window.onresize = () => {
            let w = document.documentElement.clientWidth || document.body.clientWidth;
            w >= 1900 ? this.W = true : this.W = false
        }
	},
	//更新dom时触发
	beforeUpdate: function(){},
	updated: function(){},
	beforeDestroy: function(){},
	destroyed: function(){},
	components: {},
	computed: {
	},
	methods: {
        closeDoMrp(){
            this.$parent.showMrp = false
        },
        submitSplitMaterial() {
            let dataList = this.orderList.map(item => {
                return {
                    itemId: item.itemId,
                    spliteItemList: this.spliteList.splice(0, item.len)
                }
            })
            this.$RequestUtil.post({
                url: '/api/order/doMRP',
                params: { dataList },
                type: 'sync',
                success: res => {
                    if (res.code == 0) {
                        this.$parent.loadBusinessOrderPart()
                        this.$parent.showMrp = false
                        this.$store.commit('add_reloadPages', ["/ProductionTask"])
                    } else {
                        this.$message.error(res.message || res.msg)
                    }
                }
            })

        },

        async splitOrderItem([orderId]) {
            let data = await this.loadSplitMaterial([orderId])
            let arr = []
            this.orderList = data.map(item => {
                item.dataList.forEach(sub => {
                    sub.itemId = item.itemId
                })
                arr = [...arr, ...item.dataList]
                return { itemId: item.itemId, len: item.dataList.length }
            })
            this.spliteList = arr
            // demandAmount- 毛需求量     availableAmount -可用总库存量  producingAmount - 待生产数量  needStockAmount - 抵扣库存量
            this.spliteList[0].useAmount = this.spliteList[0].demandAmount
            this.setBomMaterialCount(this.spliteList, 0)
        },

        itemCheckChange(ev, scope) {
            let index = scope.$index
            let row = scope.row

            if (row.availableAmount > 0) {

                this.setBomMaterialCount(this.spliteList, index)
            }
        },

        setBomMaterialCount(list, index) {
            //1. demandAmount 		- 毛需求数  根据物料比例关系计算出个物料需要数据
            //2. useAmount   		-实际需要数量
            //3. availableAmount  	-可用库存数
            //4. producingAmount	-实际待生产数量  通过实际需求数减去库存数量
            //5. needStockAmount    -实际抵扣库存数量
            let now = list[index]
            let layer = list[index].layer
            if (now.useStock) {  //是否需要抵扣库存
                if (now.availableAmount > now.useAmount) {   //库存数量够生产抵扣
                    now.producingAmount = 0
                    now.needStockAmount = now.useAmount
                } else {   //部分抵扣部分生产
                    if (now.availableAmount > 0) {   //当库存数量大于0(可用库存数量可能为负数)
                        now.producingAmount = now.useAmount - now.availableAmount
                        now.needStockAmount = now.availableAmount
                    } else {
                        now.producingAmount = now.useAmount
                        now.needStockAmount = 0
                    }
                }
            } else {
                now.producingAmount = now.useAmount
                now.needStockAmount = 0
            }
            now.producingAmount = this.keepTwoDecimal(now.producingAmount)  //由于比例关系为小数计算出来会丢失精度默认保留两位小数
            //由于后端返回的可用库存数量是共用的需要动态结算下一个相同物料可用库存数量availableAmount
            let lastArr = list.slice(index + 1)
            let find = lastArr.find(item => item.materialCode == now.materialCode)
            if (find) {
                if (now.availableAmount <= 0 || now.availableAmount - now.needStockAmount <= 0) {
                    find.availableAmount = 0
                } else {
                    find.availableAmount = now.availableAmount - now.needStockAmount
                }
            }
            let next = list[index + 1]
            if (next) {
                // if(next.layer>now.layer){   //下一个是当前元素的子节点
                // 	if(now.producingAmount>0){
                // 	  next.useAmount = now.producingAmount*next.priority/now.priority
                // 	}else{
                // 		next.useAmount = 0
                // 	}
                // }else{  //?需求数量如何计算
                if (next.parentId) {
                    let parent = list.find(item => item.bomId == next.parentId && item.itemId == next.itemId)  //两颗相同的bom树会找错父节点？
                    next.useAmount = (parent.producingAmount * next.priority / parent.priority)*100*100/(parent.yieldRate)/(100-next.consumptionRate)
                    log(parent.useAmount,5555)
                    next.demandAmount = (parent.producingAmount * next.priority / parent.priority)*100*100/(parent.yieldRate)/(100-next.consumptionRate)
                } else {  //next为下一颗数的根节点
                    next.useAmount = next.demandAmount
                }

                // }
                this.setBomMaterialCount(list, index + 1)
            } else {
                return
            }
        },

        keepTwoDecimal(n) {
            n = Number(n)
            return Math.round(n * 100) / 100
        },
        parseMrpType(rowData) {
            if (rowData.mrpType == 0) {
                return '自制生产'
            } else {
                return '外购'
            }
        },
        async loadSplitMaterial(orderIdList) {
            let { data, code, message, msg } = await this.$RequestUtil.postAsync({ url: '/api/order/listBomSplit', type:'sync', params: { orderIdList }, type: 'sync' })
            if (code == 0) {
                return data
            } else {
                this.$message.error(message || msg)
            }
        },

	},
	watch: {
		"isShow": async function (newVal, oldVal) {
            this.isShowDialog = this.isShow;
            if(this.isShow){
               await this.splitOrderItem([this.orderId])
            }
		},
	},
}
</script>
<style scoped>
    .delete {
        width: 18px;
        height: 19px;
        background-image: url('/static/img/del.png');
        cursor: pointer;
        background-repeat: no-repeat;
    }

    .delete:hover {
        background-image: url('/static/img/del-hover.png');
        background-repeat: no-repeat;
    }
    .title {
            color: #606266;
            font-family: NotoSansHans-Regula;
            font-size: 14px;
            display: inline-block;
            text-align: right;
            width: 70px;
        }

        .value {
            display: inline-block
        }

    @media screen and (min-width: 1300px) and (max-width: 1930px){
    
    }
</style>


<style>


</style>


// WEBPACK FOOTER //
// src/views/order/SalesOrder/DoMrp.vue